// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"953618fe","125":"1a537396","253":"4b82742b","286":"bd2b46c9","351":"11a2418e","453":"e781d6be","458":"bf1f48d0","462":"ec469cfb","502":"83ed562b","608":"385d7533","775":"70dbf21a","844":"07e33b2f","867":"950dca51","868":"4d386f0d","949":"80d8cd71"}[chunkId] + ".chunk.js";
};